import { WaterfallStructure } from 'further-types/lp/carry-settings';

export default function getDistributionWaterfallElementValue(
  waterfallElements: Array<{
    element: WaterfallStructure;
    value: number;
  }>,
  elementType: WaterfallStructure,
) {
  return waterfallElements.find((e) => e.element === elementType)?.value ?? 0;
}
